export default {
  emailOrPhone: 'E-Mail oder Telefon',
  password: 'Passwort',
  rememberMe: 'erinnern Sie sich an mich',
  forgotYourPassword: 'Sie haben Ihr Passwort vergessen?',
  signIn: 'Anmelden',
  newHere: '',
  openAccount: 'Eröffnen eines Kontos',
  haveAccount: 'Sie haben bereits ein Konto?',
  fullName: 'Vollständiger Name',
  country: 'Land',
  phone: 'Telefon',
  email: 'E-Mail',
  iAgree: 'Ich stimme der',
  termsAndConditions: 'Vereinbarung über allgemeine Geschäftsbedingungen',
  signUp: 'Anmelden',
  recoverPassword: 'Wiederherstellen Ihres Passworts',
  recover: 'Wiederherstellen',
  goBack: 'Zurück',
  weHaveSentYouACode: 'Wir haben Ihnen einen Code an Ihre',
  receivedCode: 'Empfangener Code',
  newPassword: 'Neues Passwort',
  confirmNewPassword: 'Bestätigen Sie Ihr neues Passwort',
  passwordSuccessfullyChanged: 'Kennwort erfolgreich geändert'
}
